import Overview from '@rebuild/materials/shared/announcement/Overview.vue';
import Full from './full.vue';

export const componentMap = {
    overview: Overview,
    full: Full
};